import { render } from "./NotificacaoStatusDropdown.vue?vue&type=template&id=062aa1fe"
import script from "./NotificacaoStatusDropdown.vue?vue&type=script&lang=js"
export * from "./NotificacaoStatusDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__